import React, { useState } from "react";
import styled from "styled-components";

const SettingContent = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [comment, setComment] = useState(""); // 입력된 소개 텍스트 상태
  const [newComment, setNewComment] = useState(""); // 새로 입력된 텍스트

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    document.getElementById("fileInput").click();
  };

  const handleCommentChange = (event) => {
    setNewComment(event.target.value); // 입력 필드의 값 업데이트
  };

  const applyComment = () => {
    setComment(newComment); // 새로운 텍스트를 적용
    setNewComment("");
  };

  return (
    <MySetting>
      <SettingTitleBox>
        <p className="settingTitle">프로필 설정</p>
      </SettingTitleBox>
      <ProfileSetting>
        <ProfileSettingContent>
          <div className="settingPictureBox">
            <div className="settingPicture">
              {selectedImage ? (
                <img src={selectedImage} alt="Selected" />
              ) : (
                <img
                  src="https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_01.jpg"
                  alt="프로필이미지"
                />
              )}
            </div>
            <div className="settingTextBox">
              <p className="settingId">dongsu</p>
              <p className="settingComment">
                {comment || "동스타그램에 오신 것을 환영합니다."}
              </p>
            </div>
          </div>
          <div className="settingBtn" onClick={triggerFileInput}>
            사진변경
          </div>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleImageUpload}
          />
        </ProfileSettingContent>
      </ProfileSetting>
      <CommentTitleBox>
        <p className="settingTitle">소개</p>
      </CommentTitleBox>
      <CommentEditBox>
        <input
          type="text"
          className="editCommentBox"
          placeholder="친구들에게 멋진 소개를 해보세요."
          value={newComment}
          onChange={handleCommentChange}
        />
        <div className="editCommentBtnBox">
          <div className="editCommentBtn" onClick={applyComment}>
            변경
          </div>
        </div>
      </CommentEditBox>
    </MySetting>
  );
};

export default SettingContent;

const MySetting = styled.div`
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 수평 중앙 정렬 */

  @media (max-width: 767px) {
    max-width: 767px;
    width: 70%;
  }
`;

const SettingTitleBox = styled.div`
  width: 600px;
  height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;
    margin: 0;
    margin-top: 30px;
  }

  .settingTitle {
    font-size: 1.2em;

    font-weight: 700;
  }
`;

const ProfileSetting = styled.div`
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileSettingContent = styled.div`
  width: 100%;
  height: 70px;
  border-radius: 10px;
  background-color: #f9f9f9;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    margin: 0;
  }

  .settingPictureBox {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .settingPicture {
      width: 50px;
      height: 50px;
      background-color: skyblue;
      border-radius: 50%;
      margin-left: 17px;
      overflow: hidden;
      position: relative;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      @media (max-width: 767px) {
        width: 30px;
        height: 30px;
      }

      img {
        width: 100%;

        object-fit: cover;
        border-radius: 50%;
      }
    }

    .settingTextBox {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;

      .settingId {
        font-weight: 800;
      }
      .settingComment {
        color: #8e8e8e;
        font-size: 14px;

        @media (max-width: 767px) {
          font-size: 10px;
        }
      }
    }
  }

  .settingBtn {
    padding: 10px 20px;
    border-radius: 5px;
    background-color: #0095f6;
    margin-right: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;

    @media (max-width: 767px) {
      font-size: 10px;
      padding: 7px 10px;
    }
  }
`;

const CommentTitleBox = styled.div`
  width: 100%;
  margin-top: 30px;

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;
    margin: 0;
  }
  .settingTitle {
    font-size: 1.2em;

    font-weight: 700;
  }
`;

const CommentEditBox = styled.div`
  width: 100%;
  background-color: #f9f9f9; /* 부드러운 배경색 */
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 10px;

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;
  }

  .editCommentBox {
    width: 90%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    margin-top: 15px;
    margin-bottom: 15px;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.3s ease;

    @media (max-width: 767px) {
      padding: 5px;
    }

    &:focus {
      border-color: #0095f6; /* 포커스 시 색상 변화 */
    }
  }

  .editCommentBtnBox {
    display: flex;
    justify-content: flex-end;
    width: 90%;
    margin-bottom: 10px;

    .editCommentBtn {
      background-color: #0095f6;
      color: white;
      padding: 10px 20px;
      border-radius: 5px;
      border: none;
      cursor: pointer;
      font-size: 14px;
      transition: background-color 0.3s ease;

      @media (max-width: 767px) {
        padding: 7px 10px;
        font-size: 10px;
      }

      &:hover {
        background-color: #007bb5; /* 버튼 호버 시 색상 변화 */
      }
    }
  }
`;
